import React from 'react'
import "./big.css"
import Header from './Header'
import Backflow from './Backflow'
import Navtitle from './Navtitle'

function BigNav() {
    return (
        <div className="big">
            <div className="headx"><Header/></div>
            <div className="flowx"><Backflow/></div>
            <div className="title"><Navtitle/></div>
            
        </div>
    )
}

export default BigNav
